import {
  ADVICE_ABOUT_YOU_STEP,
  ADVICE_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/Advice";

import { AdviceProductIntroFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductIntro/interfaces";
import { AkaAdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import { AdviceType } from "Store/advicePDF/interfaces";
import { AdvicePriceCalculationResult } from "Store/akaAdvice/interfaces/AkaAdviceState";
import { Partner } from "Store/partners/partnerInterfaces";
import { partnerIdSelector } from "Store/partners/partnerSelectors";
import { ReduxState } from "Store/rootReducer";
import { isDefined } from "Utils/functions";
import { isAkademikerneTheme } from "Utils/partnerUtils";
import { useSelector } from "react-redux";
import { CollectiveAdvice } from "./interfaces/CollectiveAdvice";

export const akaAdviceResultSelector = (
  state: ReduxState,
): CollectiveAdvice | null => state.akaAdvice.adviceResult.current;

export const akaAdviceIntroFormValuesSelector = (
  state: ReduxState,
): AdviceProductIntroFormValues | undefined =>
  state.priceCalculation.priceCalculationFormStates[
    ADVICE_ABOUT_YOU_STEP.id
  ] as AdviceProductIntroFormValues | undefined;

export const akaAdvicePriceFormValuesSelector = (
  state: ReduxState,
): AkaAdvicePriceFormValues | undefined =>
  state.priceCalculation.priceCalculationFormStates[ADVICE_PRICE_STEP.id] as
    | AkaAdvicePriceFormValues
    | undefined;

export const advicePriceCalculationResultsStateSelector = (
  state: ReduxState,
): AdvicePriceCalculationResult[] | null =>
  state.akaAdvice.advicePriceCalculationResults.current;

export const akaAdviceBaseAmountSelector = (state: ReduxState): number => {
  const baseAmount =
    state.akaAdvice.adviceResult.current?.additionalInformation.baseAmount;
  if (!isDefined(baseAmount)) {
    throw Error("akaAdviceBaseAmountSelector - baseAmount is not defined");
  }
  return baseAmount;
};

export const useAkaAdviceBaseAmountSelector = (): number =>
  useSelector(akaAdviceBaseAmountSelector);

export const akaAdviceNetIncomeSelector = (state: ReduxState): number => {
  const netIncome =
    state.akaAdvice.adviceResult.current?.additionalInformation.netIncome;
  if (!isDefined(netIncome)) {
    throw Error("akaAdviceNetIncomeSelector - netIncome is not defined");
  }
  return netIncome;
};

export const useAkaAdviceNetIncomeSelector = (): number =>
  useSelector(akaAdviceNetIncomeSelector);

export const adviceTypeSelector = (state: ReduxState): AdviceType =>
  isAkademikerneTheme(partnerIdSelector(state) as Partner)
    ? AdviceType.COLLECTIVE
    : AdviceType.INDIVIDUAL;

// TODO: Remove handling of old advice when no more old carts
export const hasOldAdviceSelector = ({ cart }: ReduxState): boolean =>
  isDefined(cart.current) &&
  isDefined(cart.current.advice) &&
  "adviceInitialRequest" in cart.current.advice;

export const hasNewAdviceSelector = ({ cart }: ReduxState): boolean =>
  isDefined(cart.current) &&
  isDefined(cart.current.advice) &&
  "finalAkaAdviceData" in cart.current.advice;
